import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import { CssBaseline, CircularProgress, Container, Button, Grid } from "@mui/material"
import { withStyles } from "@mui/styles"
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import Api from "../../services/api"
import * as OrganizationFieldService from '../../services/organizationfield.service'
import * as calledsActions from '../../redux/actions/calleds'
import { AbilityContext } from '../../config/ability-context'
import Footer from '../../components/footer'
import moment from "moment"
import { FormattedMessage } from 'react-intl'
import { injectIntl } from 'react-intl'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import SimpleAutoCompleteMultiple from '../../components/auto-complete/autocomplete-multiple'
import SimpleAutoCompleteMultipleCustomFieldPersonalized from '../../components/auto-complete/autocomplete-multiple-custom-field-personalized'
import Pagination from '@mui/material/Pagination'
import TextField from '@mui/material/TextField'
import 'jspdf-autotable'
import LogoMarca from '../../images/new-logo-cmtech.png'
import Divider from '@mui/material/Divider'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import CsvDownloadButton from 'react-json-to-csv'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { PapiroConsole } from "../../utils/papiroConsole"

import ApiReports from "../../services/apireport";
import ScheduleReportButton from "../../components/report-schedule";
import * as Service from '../../services/techinicalteamorganizationcategory.service';
import { getAllSelectionModelWithColorHex } from "../../services/status.service";
import SimpleCheckBox from "../../components/checkbox/check"
import { cpfMask, validateCpf } from "../../utils/cpfUtils";
import * as PriorityService from '../../services/priority.service';
import SimpleSelectWithColor from "src/components/select/simple-with-color"
import CollapsibleMaterialTable from "src/components/table/collapsible-material-table"

class CategoryChangeReport extends Component {

  constructor(props) {
    super(props)

    this.isClient = true
    this.isAdm = false
    this.typingTimeout = null
    this.organizationId = null

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3)
        this.isClient = false
      if (item.role.roletype == 0 || item.role.roletype == 1)
        this.isAdm = true
    });

    if (userSession.user.organization)
      this.organizationId = userSession.user.organization.id

    this.state = {
      dateStart: moment().format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      organizationId: this.organizationId,
      OrganizationFilter: 0,
      OrganizationListFilter: [],
      TechinicalTeamFilter: { id: 0, name: '' },
      location: 0,
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,
      calledsList: [],
      organizationList: [],
      organizationAddressesList: [],
      exportList: [],
      exportColumns: [],
      showDownloadButton: false,
      calledPdfList: [],
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      searchValue: '',
      showHeader: false,
      OrgsList: [],
      TechinicalTeamList: [],
      customFieldId: [],
      CustomFields: [],
      statusList: [],
      priorityList: [],
      priorityid: "",
      statusIds: [],
      CustomFieldNames: [],
      columnsExcell: [],
      allOrganizations: false,
      allCustomFields: false,
      requestingUserName: '',
      requestingUserEmail: '',
      requestingUserDocument: '',
      requestingDocumentError: '',
      headColumns: [],
      bodyColumns: [],
      groupId: 0,
      groupList: [],
      fullOrgList: [],
    }
  }

  async getTechinicalTeams(OrganizationId = []) {
    var result = null

    if (OrganizationId.length > 0) {
      result = await Service.getTechinicalTeamsByOrganizationList(OrganizationId);
    } else {
      result = await Service.getTechinicalTeams()
    }

    if (result.success) {
      this.setState({ TechinicalTeamList: result.data });

    } else {
      const intl = this.props.intl;
      this.setState({
        openNotification: true, notificationVariant: 'error',
        notificationMessage: result.response && result.response.data && result.response.data.errors && result.response.data.errors[0] ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  async getAllStatus() {
    let result = await getAllSelectionModelWithColorHex();
    if (result && result.success) {
      if (result.data != null)
        this.setState({ statusList: result.data })
    } else {
      const intl = this.props.intl
      this.setState({
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
    }
  }

  async getPriorities() {
    let result = await PriorityService.getAllByHirerId()

    if (result && result.success) {
      if (result.data != null)
        this.setState({ priorityList: result.data && result.data.length > 1 ? result.data.sort((a, b) => a.name.localeCompare(b.name)) : result.data })

    } else {
      const intl = this.props.intl
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
      Api.kickoff(result)
    }
  }

  async handleOrganizationListFilterChange(stateName, value) {
    if (stateName !== 'OrganizationListFilter') return;

    const organizationListFilterIds = value.map(item => item.id);

    this.setState({ [stateName]: organizationListFilterIds });

    if (organizationListFilterIds.length > 0) {
      await this.getTechinicalTeams(organizationListFilterIds)

      await this.getCustomFieldsByOrg(organizationListFilterIds)

      if (!this.state.TechinicalTeamList.find(t => t.id == this.state.TechinicalTeamFilter.id)) {
        this.setState({ TechinicalTeamFilter: { id: 0, name: '' } })
      }

    } else {
      this.setState({ TechinicalTeamFilter: { id: 0, name: '' }, TechinicalTeamList: [], customFieldId: [] })
      await this.getTechinicalTeams()
    }
  }

  changeValues = async (stateName, value, text = '') => {
    this.setState({ loading: true })

    if (stateName === 'groupId') {
      const selectedGroupId = value ? value.id : 0;
      const backupList = this.state.fullOrgList || [];

      if (selectedGroupId === 0) {
        this.setState({
          groupId: 0,
          OrgsList: backupList,
          OrganizationListFilter: [],
          loading: false
        });
        return;
      }

      const filteredOrgs = backupList.filter(org => (org.groupId === selectedGroupId));

      this.setState({
        groupId: selectedGroupId,
        OrgsList: filteredOrgs,
        OrganizationListFilter: [],
        loading: false
      });
      return;
    }

    if (stateName === 'OrganizationListFilter') {
      await this.handleOrganizationListFilterChange(stateName, value);
    }
    else if (stateName === 'customFieldId') {
      this.setState({ [stateName]: value });
    }

    else if (stateName === 'allOrganizations') {
      if (value == false) {

        if (this.state.OrganizationListFilter != null && this.state.OrganizationListFilter.length != 0) {
          await this.getCustomFieldsByOrg(this.state.OrganizationListFilter)
        }

      }
      else {
        await this.getAllCustomFields()

      }
      this.setState({ [stateName]: value });
    }

    else {
      PapiroConsole.log(value)
      PapiroConsole.log("value")
      this.setState({ [stateName]: value });
    }

    this.setState({ loading: false })
  };

  Reload = () => {
    const reload = localStorage.getItem('reload')
    if (reload == "true")
      localStorage.setItem('reload', false)
    return null;
  }

  onChange = event => {
    const { name, value } = event.target;

    if (name === 'requestingUserDocument') {
      const rawValue = value.replace(/\D/g, '');
      const isValid = rawValue.length === 11 ? validateCpf(rawValue) : true;

      this.setState({
        [name]: value,
        requestingDocumentError: !isValid
      });
    } else {
      this.setState({ [name]: value });
    }
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page })
    this.getReportsCalledsOrganizationCategory('', page)
  }

  async getCustomFieldsByOrg(organizationId) {
    this.setState({ loading: true });

    const result = await OrganizationFieldService.getAllActiveByOrganizationIdListWithoutIncludes(organizationId);

    if (result.success) {
      this.setState({ loading: false, CustomFields: result.data });
    } else {
      const intl = this.props.intl;
      this.setState({
        loading: false, openNotification: true, notificationVariant: "error",
        notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);

    }
  };

  async getAllCustomFields() {
    this.setState({ loading: true });

    const result = await OrganizationFieldService.getAllActivedWithOrganizations();

    if (result.success) {
      this.setState({ loading: false, CustomFields: result.data });
    } else {
      const intl = this.props.intl;
      this.setState({
        loading: false, openNotification: true, notificationVariant: "error",
        notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);

    }
  };

  setPagination = (count, page) => {
    let totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        if (count < 10)
          this.setState({ pageStart: 1, pageEnd: count })
        else
          this.setState({ pageStart: 1, pageEnd: 10 })
      } else {
        let pageStart = ((page - 1) * 10) + 1
        if (count >= page * 10)
          this.setState({ pageStart: pageStart, pageEnd: page * 10 })
        else
          this.setState({ pageStart: pageStart, pageEnd: count })
      }
    } else
      this.setState({ totalPages: 0, page: 1, count: 0 })
  }

  getGroups = async () => {
    try {
      const result = await Api.get('/groups');
      if (result.data) {
        this.setState({ groupList: result.data.data || result.data });
      }
    } catch (err) {
      console.log("Erro ao buscar grupos", err);
    }
  }

  getOrganizations = async _ => {
    try {
      const result = await Api.get('/organizations/tech');

      let data = [];
      if (result.data && result.data.data) {
        data = result.data.data;
      } else if (result.data && Array.isArray(result.data)) {
        data = result.data;
      }

      const dataNormalizada = data.map(item => {
        const orgReal = item.organization || item;
        return {
          ...orgReal,
          groupId: orgReal.groupId || orgReal.groupid || orgReal.GroupId || (orgReal.Group ? orgReal.Group.Id : null)
        };
      });

      this.setState({
        OrgsList: dataNormalizada,
        fullOrgList: dataNormalizada,
        loading: false
      })
    } catch (err) {
      console.log("Erro ao buscar organizações:", err);
      this.setState({ OrgsList: [], loading: false });
    }
  }

  async componentDidMount() {
    this.setState({ loading: true })

    await this.getGroups();
    await this.getOrganizations()
    await this.getTechinicalTeams()
    await this.getAllStatus()
    await this.getPriorities()

    this.setState({ loading: false })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload")
      this.componentDidMount()
  }

  getFileNew = async () => {
    this.setState({ loading: true })

    var list

    //checando se a opção de selecionar todos os campos personalizados está marcada
    if (this.state.allCustomFields == true) {
      list = this.state.CustomFields;
    }
    else {
      list = this.state.customFieldId;
    }

    var customfieldids = "";
    var customfieldNames = []
    var customfieldnamestoback = ""

    if (list != null && list != "") {
      for (let value in list) {
        customfieldids = list[value].id + "," + customfieldids;
        customfieldNames.unshift(list[value].name)
        customfieldnamestoback = list[value].name + "ƒ" + customfieldnamestoback;

      }
      if (customfieldids.length > 0) {
        customfieldids = customfieldids.substr(0, customfieldids.length - 1);
        customfieldnamestoback = customfieldnamestoback.substr(0, customfieldnamestoback.length - 1);
      }
    }

    var status = ""
    if (this.state.statusIds != null && this.state.statusIds.length > 0) {
      let ids = this.state.statusIds.map(c => c.id);
      status = ids.join(',');
    }

    let data = {
      OrganizationId: this.state.OrganizationListFilter,
      TechinicalTeamId: this.state.TechinicalTeamFilter.id,
      DateStart: moment(this.state.dateStart).format('YYYY-MM-DD'),
      DateEnd: moment(this.state.dateEnd).format('YYYY-MM-DD'),
      CustomFieldIds: customfieldids,
      customfieldnamestoback: customfieldnamestoback,
      StatusIds: status,
      AllOrganizationsChecked: this.state.allOrganizations,
      RequestingUserName: this.state.requestingUserName || '',
      RequestingUserEmail: this.state.requestingUserEmail || '',
      RequestingUserDocument: this.state.requestingUserDocument || '',
      priorityId: this.state.priorityid,
      GroupId: this.state.groupId
    }

    let url = `/report/calledsorganizationcategory/excel?code=calledorgreport`;

    ApiReports.post(url, data)
      .then((response) => {
        if (response.data.success) {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'success',
            notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")",
          });
        } else {
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: 'error',
            notificationMessage: response.data.errors && response.data.errors[0] ? response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: 'error',
          notificationMessage: error.data && error.data.response && error.data.response.data && error.data.response.data.errors && error.data.response.data.errors[0] ? error.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
        });
      });
  }

  getColumns(data, customfieldNames) {
    const intl = this.props.intl;

    var headColumns =
      [
        { title: intl.formatMessage({ id: "called.transtion.status.id" }), field: 'called_id' },
        { title: intl.formatMessage({ id: "called.transtion.status.type" }), field: 'type' },
      ];

    var bodyColumns =
      [
        { title: intl.formatMessage({ id: "previous.organization.category" }), field: 'previous_category' },
        { title: intl.formatMessage({ id: "next.organization.category" }), field: 'next_category' },
        { title: intl.formatMessage({ id: "called.transtion.status.user" }), field: 'user' },
        { title: intl.formatMessage({ id: "called.transtion.status.changedate" }), field: 'category_change_data' },
      ];

    var i = 1;

    if (customfieldNames.length > 0) {
      customfieldNames.forEach(element => {
        bodyColumns.push({ title: element, field: `campo_personalizado${i}` })
        i++
      });
    }

    this.setState({
      headColumns,
      bodyColumns
    })
  }

  orderById(arr) {
    const result = arr.sort((a, b) => {
      return a.id - b.id;
    });

    return result;
  }

  groupByCalledId(arr) {
    if (!Array.isArray(arr) || arr.length === 0) {
      return [];
    }

    const map = {};

    arr.forEach(item => {
      const key = item.called_id !== undefined && item.called_id !== null
        ? item.called_id
        : 0;

      if (!map[key]) {
        map[key] = [];
      }

      map[key].push(item);
    });

    const result = Object.keys(map)
      .sort((a, b) => {
        if (a === 0) return 1;
        if (b === 0) return -1;
        return b - a;
      })
      .map(key => ({
        called_id: key,
        type: map?.[key]?.[0]?.type || "",
        calledsList: this.orderById(map[key])
      }));

    return result;
  }

  getReportsCalledsOrganizationCategory = async (filter = '', page = 1) => {
    this.setState({ loading: true, exportList: [], showDownloadButton: false });

    var list
    //checando se a opção de selecionar todos os campos personalizados está marcada
    if (this.state.allCustomFields == true) {
      list = this.state.CustomFields;
    }
    else {
      list = this.state.customFieldId;
    }

    var customfieldids = "";
    var customfieldNames = []

    if (list != null && list != "") {

      for (let value in list) {

        customfieldids = list[value].id + "," + customfieldids;

        customfieldNames.unshift(list[value].name)
      }

      if (customfieldids.length > 0) {
        customfieldids = customfieldids.substr(0, customfieldids.length - 1);
      }
    }

    var status = ""
    if (this.state.statusIds != null && this.state.statusIds.length > 0) {
      let ids = this.state.statusIds.map(c => c.id);
      status = ids.join(',');
    }
    var dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    var dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (dateStart > dateEnd) {
      const { intl } = this.props
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: intl.formatMessage({ id: "report.audit.initial.date.higher.than.end.date" }),
        loading: false
      });
    }
    else {
      if (this.state.priorityid == null || this.state.priorityid == 0) {
        this.state.priorityid = ""
      }

      let url = `/report/calledsorganizationcategory/paginate`
      url += `?page=${page}`
      url += `&org=${this.state.OrganizationListFilter}`
      url += `&techteam=${this.state.TechinicalTeamFilter.id}`
      url += `&dateStart=${moment(this.state.dateStart).format('YYYY-MM-DD')}`
      url += `&dateEnd=${moment(this.state.dateEnd).format('YYYY-MM-DD')}`
      url += `&customfieldids=${customfieldids}`
      url += `&status=${status}`
      url += `&allorganizationschecked=${this.state.allOrganizations}`
      url += `&requestingUserName=${this.state.requestingUserName}`
      url += `&requestingUserEmail=${this.state.requestingUserEmail}`
      url += `&requestingUserDocument=${this.state.requestingUserDocument}`
      url += `&priority=${this.state.priorityid}`
      url += `&groupId=${this.state.groupId}`

      this.setState({ showGrid: true, scheduleRequest: url + (customfieldNames.length > 0 ? `&customfieldnamestoback=${encodeURIComponent(customfieldNames.join('ƒ'))}` : '') })

      ApiReports.get(url)
        .then(result => {
          if (result.data.success) {
            let count = result.data.count
            this.setState({ count: count })
            this.setPagination(count, page)

            const data = result.data.data;

            const formattedList = this.groupByCalledId(data);

            this.setState({ calledsList: formattedList, loading: false })

            this.getColumns(formattedList, customfieldNames)

          } else {
            this.setState({
              loading: false, openNotification: true, notificationVariant: 'error',
              notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
            })
            Api.kickoff(result)
          }
        })
        .catch(err => {
          this.setState({
            loading: false, openNotification: true, notificationVariant: "error",
            notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({ id: "process.error" })
          })
          Api.kickoff(err)
        })
    }
  }

  handleSubmit = async e => {
    e.preventDefault();

    if (this.state.showDownloadButton) {
      this.setState({ showDownloadButton: false });
      return false;
    }
    this.setState({ loading: true });
    await this.getReportsCalledsOrganizationCategory(this.props.location.state)
  }

  closeNotification = _ => {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props
    const intl = this.props.intl

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    const tableList = () => {
      return (
        <>
          <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
            <Accordion >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>{intl.formatMessage({ id: "filters" })}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container style={{ marginBottom: 20 }} spacing={2}>
                  <Grid item xs={12} sm={6} md={4}  >
                    <SimpleDatePicker label={intl.formatMessage({ id: "start.date" })} name='dateStart' stateName='dateStart' changeDate={this.changeValues} currentDate={this.state.dateStart} fullWidth={true} required />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} >
                    <SimpleDatePicker label={intl.formatMessage({ id: "end.date" })} name='dateEnd' stateName='dateEnd' changeDate={this.changeValues} currentDate={this.state.dateEnd} fullWidth={true} required />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} >
                    <SimpleAutoComplete label="Grupo" options={this.state.groupList} stateName='groupId' selected={this.state.groupList.find(x => x.id === this.state.groupId) || null} changeSelect={this.changeValues} getOptionLabel={(option) => option.Name || option.name || ""} />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} >
                    <SimpleAutoCompleteMultiple key={this.state.groupId} label={intl.formatMessage({ id: "organization" })} options={this.state.OrgsList} stateName='OrganizationListFilter' changeSelect={this.changeValues} />

                    <SimpleCheckBox label={intl.formatMessage({ id: "select.all.organizations" })} name='allOrganizations' stateName='allOrganizations' changeSelect={this.changeValues} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} >
                    <SimpleAutoComplete label={intl.formatMessage({ id: "productivity.dashboard.techinical.teams" })} options={this.state.TechinicalTeamList} stateName='TechinicalTeamFilter' selected={this.state.TechinicalTeamFilter} changeSelect={this.changeValues} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} >
                    <SimpleAutoCompleteMultipleCustomFieldPersonalized label={intl.formatMessage({ id: "organization.custom.fields" })} options={this.state.CustomFields} stateName='customFieldId' changeSelect={this.changeValues} selected={this.state.customFieldId} disabled={this.state.allCustomFields} />
                    <SimpleCheckBox label={intl.formatMessage({ id: "select.all.custom.fields" })} name='allCustomFields' stateName='allCustomFields' changeSelect={this.changeValues} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} >
                    <SimpleAutoCompleteMultiple label={intl.formatMessage({ id: "menu.statuses" })} options={this.state.statusList} stateName='statusIds' changeSelect={this.changeValues} selected={this.state.statusIds} />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <TextField type="text"
                      fullWidth
                      inputProps={{ maxLength: 14 }}
                      autoComplete="off"
                      variant="outlined"
                      name="requestingUserDocument"
                      value={cpfMask(this.state.requestingUserDocument)}
                      placeholder={intl.formatMessage({ id: "requesting.user.document" })}
                      onChange={this.onChange}
                      error={this.state.requestingDocumentError}
                      helperText={this.state.requestingDocumentError ? intl.formatMessage({ id: "invalid.cpf" }) : ""}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <TextField type="text"
                      fullWidth
                      inputProps={{ maxLength: 255 }}
                      autoComplete="fname"
                      variant="outlined"
                      name="requestingUserName"
                      value={this.state.requestingUserName}
                      placeholder={intl.formatMessage({ id: "requesting.user.name" })}
                      onChange={this.onChange} />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <TextField type="email"
                      fullWidth
                      inputProps={{ maxLength: 255 }}
                      autoComplete="email"
                      variant="outlined"
                      name="requestingUserEmail"
                      value={this.state.requestingUserEmail}
                      placeholder={intl.formatMessage({ id: "requesting.user.email" })}
                      onChange={this.onChange} />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} >
                    <SimpleSelectWithColor
                      label={intl.formatMessage({ id: "priority" })}
                      options={this.state.priorityList}
                      stateName="priorityid"
                      changeSelect={this.changeValues}
                      selected={this?.state?.priorityid} />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Grid container style={{ marginBottom: 10 }}>
              <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button
                  type='submit'
                  fullWidth
                  variant='contained'
                  color='secondary' >
                  {<FormattedMessage id="filter" />}
                </Button>
              </Grid>

              {this.state.showGrid && <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <Button
                  fullWidth
                  variant='contained'
                  color='secondary'
                  onClick={this.getFileNew} >
                  {<FormattedMessage id="export.plan" />}
                </Button>
              </Grid>}
{this.state.showGrid && this.state.scheduleRequest && <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
  <ScheduleReportButton reportKey="category-change" request={this.state.scheduleRequest} color="secondary" />
</Grid>}

              {this.state.showDownloadButton && <Grid item xs={12} sm={5} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                <CsvDownloadButton
                  data={this.state.exportList}
                  filename={`./${Date.now()}_relatorio_mudanca_categoria.xlsx`}
                  delimiter={";"}
                  headers={this.state.exportColumns}
                  style={{
                    boxShadow: "inset 0px 1px 0px 0px #277afe",
                    background: "linear-gradient(to bottom, #277afe 5%, #277afe 100%)",
                    backgroundColor: "#277afe",
                    borderRadius: "6px",
                    border: "1px solid #277afe",
                    display: "inline-block",
                    cursor: "pointer", "color": "#ffffff",
                    fontSize: "15px",
                    fontWeight: "bold",
                    padding: "6px 24px",
                    textDecoration: "none",
                    textShadow: "0px 1px 0px #277afe"
                  }}
                >
                  {<FormattedMessage id="download" />}
                </CsvDownloadButton>
              </Grid>}
            </Grid>
          </form>

          {
            this.state.showGrid &&
            <>
              <Grid container xs={12}>
                <CollapsibleMaterialTable
                  headColumns={this.state.headColumns}
                  bodyColumns={this.state.bodyColumns}
                  bodyData={this.state.calledsList}
                  mainListKey={"calledsList"}
                  allOpened
                />
              </Grid>

              <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                  <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                  {this.state.pageStart} {<FormattedMessage id="to" />} {this.state.pageEnd} {<FormattedMessage id="of" />} {this.state.count} {<FormattedMessage id="register" />}
                </Grid>
              </Grid>
            </>
          }
        </>
      );
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })} >
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />
            {this.state.showHeader &&
              <Grid container>
                <Grid id="header-pdf" item lg={4} sm={12} xl={this.state.grid} xs={12} style={{ padding: '2px' }}>
                  <Card >
                    <CardContent>
                      <img src={LogoMarca} style={{ width: "70px" }} /> <span style={{ marginLeft: 25, fontSize: 18 }}>

                        <FormattedMessage id="menu.category.change.report" />
                      </span>
                      <Divider />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            }

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card >
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      <FormattedMessage id="menu.category.change.report" />
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>


            {tableList()}


            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

CategoryChangeReport.propTypes = {
  classes: PropTypes.object.isRequired
}


const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(CategoryChangeReport)))
CategoryChangeReport.contextType = AbilityContext
